import { createContext } from 'react';
import PropTypes from '@squiz/xaccel-prop-types';
const AssistedInputContext = /*#__PURE__*/createContext({
  id: undefined,
  assistActive: false,
  isFetching: false,
  inputValue: '',
  activeDescendant: undefined,
  isPopup: true,
  onInputChange: undefined,
  onKeyUp: undefined,
  onKeyDown: undefined,
  registerChildIds: undefined,
  registerInputRef: undefined,
  readerAnnounce: undefined,
  setIsFetching: undefined
});
AssistedInputContext.Provider.propTypes = {
  value: PropTypes.shape({
    id: PropTypes.string,
    assistActive: PropTypes.bool,
    isFetching: PropTypes.bool,
    inputValue: PropTypes.string,
    activeDescendant: PropTypes.string,
    isPopup: PropTypes.bool,
    onInputChange: PropTypes.func,
    onKeyUp: PropTypes.func,
    onKeyDown: PropTypes.func,
    registerChildIds: PropTypes.func,
    registerInputRef: PropTypes.func,
    readerAnnounce: PropTypes.string,
    setIsFetching: PropTypes.func
  })
};
export default AssistedInputContext;